/** Shared helpers so every screen goes through the axios `api` instance.
 *  Auth is cookie-based (`withCredentials: true`) + CSRF token — no localStorage
 *  reads, no manual `Authorization` headers. Keeps ~20 pages / components DRY.
 */
import api from "./api";
import { toast } from "sonner";

/** GET a binary from `${API}${path}` and save it as `filename`.
 *  `params` becomes the query string. Toasts on error. */
export async function downloadBlob(path, filename, params = {}) {
  try {
    // Accept either { ...queryparams } OR { method: "POST"|"GET", data: {...}, params: {...} }
    const isPost = params && typeof params === "object" && String(params.method || "").toUpperCase() === "POST";
    let res;
    if (isPost) {
      res = await api.post(path, params.data || {}, {
        params: params.params || {},
        responseType: "blob",
      });
    } else {
      res = await api.get(path, { params, responseType: "blob" });
    }
    const url = URL.createObjectURL(res.data);
    const a = document.createElement("a");
    a.href = url; a.download = filename;
    document.body.appendChild(a); a.click(); a.remove();
    URL.revokeObjectURL(url);
    return true;
  } catch (e) {
    console.warn("[download] failed:", path, e?.message);
    toast.error(e?.response?.data?.detail || `Download failed: ${filename}`);
    return false;
  }
}

/** POST a single File via multipart. `extra` are additional form fields. */
export async function uploadFile(path, file, extra = {}) {
  const fd = new FormData();
  fd.append("file", file);
  for (const [k, v] of Object.entries(extra)) fd.append(k, v);
  return api.post(path, fd);
}

/** Open the returned HTML in a new window/tab (cookie-auth respected). */
export async function openHtmlInNewTab(path, params = {}) {
  const w = window.open("", "_blank");
  try {
    const res = await api.get(path, { params, responseType: "text" });
    w.document.write(res.data);
    return w;
  } catch (e) {
    w?.close();
    toast.error(e?.response?.data?.detail || "Preview failed");
    return null;
  }
}
